function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { initializerDefineProperty as _initializerDefineProperty, applyDecoratedDescriptor as _applyDecoratedDescriptor, objectSpread2 as _objectSpread2 } from "../_virtual/_rollupPluginBabelHelpers.js";
import { observable, computed, action } from 'mobx';
import AssignmentStore from "./AssignmentStore.js";
import { orderBy } from 'lodash';
import SignatureStore from "./SignatureStore.js";
import AnnotationField from "./AnnotationField.js";
import { DrawMode } from "../types/index.js";
import { positionComparator } from "./PdfPageStore.js";
import { isMobileView } from "../helpers/layoutUtils.js";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _temp;

function fieldDataComparator(a, b) {
  if (!a.label || !b.label) {
    return 0;
  }

  return a.label < b.label ? -1 : 1;
}

var PdfStore = (_class = (_temp = /*#__PURE__*/function () {
  function PdfStore() {
    _classCallCheck(this, PdfStore);

    var fieldData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    this.assignmentStore = void 0;
    this.signatureStore = void 0;

    _initializerDefineProperty(this, "documentProxy", _descriptor, this);

    _initializerDefineProperty(this, "documents", _descriptor2, this);

    _initializerDefineProperty(this, "fieldData", _descriptor3, this);

    _initializerDefineProperty(this, "selectedFields", _descriptor4, this);

    _initializerDefineProperty(this, "lastFieldClicked", _descriptor5, this);

    _initializerDefineProperty(this, "copiedFields", _descriptor6, this);

    _initializerDefineProperty(this, "isDraggingField", _descriptor7, this);

    _initializerDefineProperty(this, "resizingField", _descriptor8, this);

    _initializerDefineProperty(this, "isDataDirty", _descriptor9, this);

    _initializerDefineProperty(this, "drawMode", _descriptor10, this);

    _initializerDefineProperty(this, "highlightUnassignedFields", _descriptor11, this);

    _initializerDefineProperty(this, "fieldsWithPriorValuesDisabled", _descriptor12, this);

    _initializerDefineProperty(this, "modifyingFieldPropertiesEnabled", _descriptor13, this);

    _initializerDefineProperty(this, "signingDisabled", _descriptor14, this);

    _initializerDefineProperty(this, "signableOnly", _descriptor15, this);

    _initializerDefineProperty(this, "documentSubmitted", _descriptor16, this);

    _initializerDefineProperty(this, "documentParties", _descriptor17, this);

    _initializerDefineProperty(this, "documentPartyMappings", _descriptor18, this);

    _initializerDefineProperty(this, "pdfTitle", _descriptor19, this);

    _initializerDefineProperty(this, "pdfType", _descriptor20, this);

    _initializerDefineProperty(this, "contextMenu", _descriptor21, this);

    _initializerDefineProperty(this, "pdfContainerWidth", _descriptor22, this);

    _initializerDefineProperty(this, "selectedTemplateIds", _descriptor23, this);

    _initializerDefineProperty(this, "fillableTemplateIds", _descriptor24, this);

    _initializerDefineProperty(this, "templatePickerModalOpen", _descriptor25, this);

    _initializerDefineProperty(this, "timeZone", _descriptor26, this);

    _initializerDefineProperty(this, "lastKnownMouseLocation", _descriptor27, this);

    _initializerDefineProperty(this, "shiftKeyHeldDown", _descriptor28, this);

    _initializerDefineProperty(this, "pdfWrapperRef", _descriptor29, this);

    _initializerDefineProperty(this, "setIsDataDirty", _descriptor30, this);

    _initializerDefineProperty(this, "setDrawMode", _descriptor31, this);

    _initializerDefineProperty(this, "setDocumentParties", _descriptor32, this);

    _initializerDefineProperty(this, "setDocumentPartyMappings", _descriptor33, this);

    _initializerDefineProperty(this, "setSelectedFields", _descriptor34, this);

    _initializerDefineProperty(this, "addSelectedField", _descriptor35, this);

    _initializerDefineProperty(this, "setLastFieldClicked", _descriptor36, this);

    _initializerDefineProperty(this, "setCopiedFields", _descriptor37, this);

    _initializerDefineProperty(this, "setIsDraggingField", _descriptor38, this);

    _initializerDefineProperty(this, "setResizingField", _descriptor39, this);

    _initializerDefineProperty(this, "deleteSelectedFields", _descriptor40, this);

    _initializerDefineProperty(this, "focusField", _descriptor41, this);

    _initializerDefineProperty(this, "zoomIn", _descriptor42, this);

    _initializerDefineProperty(this, "zoomOut", _descriptor43, this);

    _initializerDefineProperty(this, "resolveData", _descriptor44, this);

    _initializerDefineProperty(this, "resolveAllData", _descriptor45, this);

    _initializerDefineProperty(this, "addFieldData", _descriptor46, this);

    _initializerDefineProperty(this, "setHighlightUnassignedFields", _descriptor47, this);

    _initializerDefineProperty(this, "setFieldsWithPriorValuesDisabled", _descriptor48, this);

    _initializerDefineProperty(this, "setModifyingFieldPropertiesEnabled", _descriptor49, this);

    _initializerDefineProperty(this, "setSigningDisabled", _descriptor50, this);

    _initializerDefineProperty(this, "setSignableOnly", _descriptor51, this);

    _initializerDefineProperty(this, "setDocumentSubmitted", _descriptor52, this);

    _initializerDefineProperty(this, "setPdfTitle", _descriptor53, this);

    _initializerDefineProperty(this, "setPdfType", _descriptor54, this);

    _initializerDefineProperty(this, "submitDocument", _descriptor55, this);

    _initializerDefineProperty(this, "setContextMenu", _descriptor56, this);

    _initializerDefineProperty(this, "addDocument", _descriptor57, this);

    _initializerDefineProperty(this, "setPdfContainerWidth", _descriptor58, this);

    _initializerDefineProperty(this, "setSelectedTemplateIds", _descriptor59, this);

    _initializerDefineProperty(this, "setFillableTemplateIds", _descriptor60, this);

    _initializerDefineProperty(this, "setTemplatePickerModalOpen", _descriptor61, this);

    _initializerDefineProperty(this, "setDocuments", _descriptor62, this);

    _initializerDefineProperty(this, "setPdfWrapperRef", _descriptor63, this);

    _initializerDefineProperty(this, "setTimeZone", _descriptor64, this);

    _initializerDefineProperty(this, "setLastKnownMouseLocation", _descriptor65, this);

    _initializerDefineProperty(this, "setShiftKeyHeldDown", _descriptor66, this);

    _initializerDefineProperty(this, "ensureNextPrevFieldPagesAreRendered", _descriptor67, this);

    this.assignmentStore = new AssignmentStore(this);
    this.signatureStore = new SignatureStore(this);
    this.fieldData = fieldData;
  }

  _createClass(PdfStore, [{
    key: "selectedField",
    get: function get() {
      return this.selectedFields ? this.selectedFields[0] : undefined;
    }
  }, {
    key: "orderedFieldData",
    get: function get() {
      return this.fieldData.slice().sort(fieldDataComparator);
    }
  }, {
    key: "groupedFieldData",
    get: function get() {
      var options = [];
      this.fieldData.forEach(function (datum) {
        if (!datum.label || !datum.group) return;
        var existingGroup = options.find(function (group) {
          return group.label === datum.group;
        });
        var option = {
          label: datum.label,
          value: datum
        };

        if (existingGroup) {
          existingGroup.options.push(option);
        } else {
          options.push({
            label: datum.group,
            options: [option]
          });
        }
      });
      return options;
    }
  }, {
    key: "mergeFieldOptions",
    get: function get() {
      if (this.fieldData.every(function (datum) {
        return datum.group;
      })) {
        return this.groupedFieldData;
      }

      return this.orderedFieldData.map(function (datum) {
        return {
          label: datum.label || '',
          value: datum
        };
      });
    }
  }, {
    key: "fields",
    get: function get() {
      return this.documents.reduce(function (acc, documentStore) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(documentStore.fields));
      }, []);
    }
  }, {
    key: "orderedFields",
    get: function get() {
      var fields = [];
      this.orderedDocuments.forEach(function (document) {
        document.pages.forEach(function (page) {
          fields.push.apply(fields, _toConsumableArray(page.fields.sort(positionComparator)));
        });
      });
      return fields;
    }
  }, {
    key: "orderedDocuments",
    get: function get() {
      return orderBy(this.documents, ['index'], ['asc']);
    }
  }, {
    key: "allPdfsLoaded",
    get: function get() {
      return !!this.documents.length && this.documents.every(function (document) {
        return document.pdfLoaded;
      });
    }
  }, {
    key: "currentPageStore",
    get: function get() {
      var _this = this;

      if (!this.selectedField) return undefined;
      var pageStore;
      this.documents.forEach(function (document) {
        var currentPageStore = document.pages.find(function (page) {
          return page.fields.includes(_this.selectedField);
        });

        if (currentPageStore) {
          pageStore = currentPageStore;
        }
      });
      return pageStore;
    }
  }, {
    key: "getPageStore",
    value: function getPageStore(field) {
      var pageStore;
      this.documents.forEach(function (document) {
        var currentPageStore = document.pages.find(function (page) {
          return page.fields.includes(field);
        });

        if (currentPageStore) {
          pageStore = currentPageStore;
        }
      });
      return pageStore;
    }
  }, {
    key: "isFieldSignable",
    value: function isFieldSignable(field, userId, userPermissions) {
      return (field === null || field === void 0 ? void 0 : field.data.dataType) === 'signing' && (field === null || field === void 0 ? void 0 : field.data.valueType) !== 'date' && !field.data.signedAt && !this.signingDisabled && field.belongsTo(userId, userPermissions);
    }
  }, {
    key: "selectedFieldsMatch",
    value: function selectedFieldsMatch(data) {
      if (!this.selectedFields) return false;
      var keys = Object.keys(data);

      for (var i = 0; i < this.selectedFields.length; i++) {
        var fieldData = this.selectedFields[i].data;

        for (var j = 0; j < keys.length; j++) {
          var key = keys[j];

          if (fieldData[key] !== data[key]) {
            return false;
          }
        }
      }

      return true;
    }
  }, {
    key: "selectedFieldsIncludes",
    value: function selectedFieldsIncludes(data) {
      if (!this.selectedFields) return false;
      var keys = Object.keys(data);

      for (var i = 0; i < this.selectedFields.length; i++) {
        var fieldData = this.selectedFields[i].data;
        var fieldIncluded = true;

        for (var j = 0; j < keys.length; j++) {
          var key = keys[j];

          if (fieldData[key] !== data[key]) {
            fieldIncluded = false;
          }
        }

        if (fieldIncluded) return true;
      }

      return false;
    }
  }, {
    key: "nextField",
    value: function nextField(userId, userPermissions) {
      var orderedAssignedFields = AnnotationField.getAssignedFields(this.orderedFields, userId, userPermissions);
      var currentFieldIndex = this.selectedField ? orderedAssignedFields.indexOf(this.selectedField) : -1;

      while (currentFieldIndex < orderedAssignedFields.length - 1) {
        var nextField = orderedAssignedFields[currentFieldIndex + 1]; // Use the field data since the component isn't guaranteed
        // to have been rendered

        if (nextField.data.dataType === 'signing' && this.signingDisabled || nextField.data.dataType === 'manual' && this.signableOnly) {
          currentFieldIndex += 1;
        } else {
          return nextField;
        }
      }

      return undefined;
    }
  }, {
    key: "previousField",
    value: function previousField(userId, userPermissions) {
      var orderedAssignedFields = AnnotationField.getAssignedFields(this.orderedFields, userId, userPermissions);

      if (this.selectedField) {
        var currentFieldIndex = orderedAssignedFields.indexOf(this.selectedField);

        while (currentFieldIndex > 0) {
          var prevField = orderedAssignedFields[currentFieldIndex - 1]; // Use the field data since the component isn't guaranteed
          // to have been rendered

          if (prevField.data.dataType === 'signing' && this.signingDisabled || prevField.data.dataType === 'manual' && this.signableOnly) {
            currentFieldIndex -= 1;
          } else {
            return prevField;
          }
        }

        return undefined;
      }

      return undefined;
    }
  }]);

  return PdfStore;
}(), _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "documentProxy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "documents", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fieldData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "selectedFields", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "lastFieldClicked", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "copiedFields", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isDraggingField", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "resizingField", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isDataDirty", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "drawMode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return DrawMode.Autofill;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "highlightUnassignedFields", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "fieldsWithPriorValuesDisabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "modifyingFieldPropertiesEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "signingDisabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "signableOnly", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "documentSubmitted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "documentParties", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "documentPartyMappings", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "pdfTitle", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "pdfType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "contextMenu", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "pdfContainerWidth", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "selectedTemplateIds", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "fillableTemplateIds", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "templatePickerModalOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "timeZone", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "lastKnownMouseLocation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "shiftKeyHeldDown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "pdfWrapperRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "selectedField", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedField"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderedFieldData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderedFieldData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "groupedFieldData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupedFieldData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mergeFieldOptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mergeFieldOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderedFields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderedFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderedDocuments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderedDocuments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allPdfsLoaded", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allPdfsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentPageStore", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentPageStore"), _class.prototype), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "setIsDataDirty", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (dataDirty) {
      _this2.isDataDirty = dataDirty;
    };
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "setDrawMode", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (drawMode) {
      _this3.copiedFields = undefined;
      _this3.drawMode = drawMode;
    };
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "setDocumentParties", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (parties) {
      _this4.documentParties = parties;
    };
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "setDocumentPartyMappings", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (parties) {
      _this5.documentPartyMappings = parties;
    };
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "setSelectedFields", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (fields) {
      _this6.selectedFields = fields;
    };
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "addSelectedField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;

    return function (field) {
      if (_this7.selectedFields) {
        if (!_this7.selectedFields.includes(field)) {
          _this7.selectedFields.push(field);
        }
      } else {
        _this7.selectedFields = [field];
      }
    };
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "setLastFieldClicked", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;

    return function (field) {
      _this8.lastFieldClicked = field;
    };
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "setCopiedFields", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;

    return function (fields) {
      _this9.drawMode = undefined;
      _this9.copiedFields = fields;
    };
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "setIsDraggingField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;

    return function (isDraggingField) {
      _this10.isDraggingField = isDraggingField;
    };
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "setResizingField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this11 = this;

    return function (field) {
      _this11.resizingField = field;
    };
  }
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "deleteSelectedFields", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this12 = this;

    return function () {
      if (!_this12.selectedFields) return;

      _this12.selectedFields.forEach(function (field) {
        _this12.documents.forEach(function (document) {
          var pageStore = document.pages.find(function (page) {
            return page.pageNumber === field.page;
          });
          pageStore === null || pageStore === void 0 ? void 0 : pageStore.deleteField(field);
        });
      });

      _this12.selectedFields = undefined;
      _this12.lastFieldClicked = undefined;
    };
  }
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "focusField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this13 = this;

    return function (field) {
      _this13.setSelectedFields([field]);

      var fieldEl = document.getElementById("fillable-field-anchor-".concat(field.id));
      fieldEl === null || fieldEl === void 0 ? void 0 : fieldEl.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      }); // Focusing the field here makes it so the user doesn't have to click to
      // start typing, but on mobile this causes undesirable behavior like not
      // scrolling to the correct location if zoomed in and the keyboard covering
      // the next/prev field buttons.

      if (!isMobileView()) fieldEl === null || fieldEl === void 0 ? void 0 : fieldEl.focus();
    };
  }
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "zoomIn", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this14 = this;

    return function () {
      _this14.documents.forEach(function (document) {
        document.scale += 0.25;
      });
    };
  }
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "zoomOut", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this15 = this;

    return function () {
      _this15.documents.forEach(function (document) {
        if (document.scale > 0.25) {
          document.scale -= 0.25;
        }
      });
    };
  }
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "resolveData", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (annotationFieldData, allFieldData) {
      if (annotationFieldData.dataType === 'manual' || allFieldData.length === 1) {
        return annotationFieldData;
      }

      var result = allFieldData.filter(function (data) {
        return data.dataType === 'autofill';
      }).find(function (datum) {
        return datum.sourceKey === annotationFieldData.sourceKey;
      });
      return _objectSpread2(_objectSpread2({}, annotationFieldData), result);
    };
  }
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "resolveAllData", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this16 = this;

    return function (fields) {
      fields.forEach(function (field) {
        field.setData(_this16.resolveData(field.data, _this16.fieldData));
      });
    };
  }
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "addFieldData", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this17 = this;

    return function (sources) {
      sources.forEach(function (source) {
        return _this17.fieldData.push(_objectSpread2({}, source));
      });

      _this17.resolveAllData(_this17.fields);
    };
  }
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "setHighlightUnassignedFields", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this18 = this;

    return function (highlightUnassignedFields) {
      _this18.highlightUnassignedFields = highlightUnassignedFields;
    };
  }
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "setFieldsWithPriorValuesDisabled", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this19 = this;

    return function (fieldsWithPriorValuesDisabled) {
      _this19.fieldsWithPriorValuesDisabled = fieldsWithPriorValuesDisabled;
    };
  }
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "setModifyingFieldPropertiesEnabled", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this20 = this;

    return function (modifyingFieldPropertiesEnabled) {
      _this20.modifyingFieldPropertiesEnabled = modifyingFieldPropertiesEnabled;
    };
  }
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "setSigningDisabled", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this21 = this;

    return function (signingDisabled) {
      _this21.signingDisabled = signingDisabled;
    };
  }
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "setSignableOnly", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this22 = this;

    return function (disableManualFields) {
      _this22.signableOnly = disableManualFields;
    };
  }
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "setDocumentSubmitted", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this23 = this;

    return function (documentSubmitted) {
      _this23.documentSubmitted = documentSubmitted;
    };
  }
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "setPdfTitle", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this24 = this;

    return function (pdfTitle) {
      _this24.pdfTitle = pdfTitle;
    };
  }
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "setPdfType", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this25 = this;

    return function (pdfType) {
      _this25.pdfType = pdfType;
    };
  }
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "submitDocument", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this26 = this;

    return function () {
      _this26.setDocumentSubmitted(true);
    };
  }
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "setContextMenu", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this27 = this;

    return function (contextMenu) {
      _this27.contextMenu = contextMenu;
    };
  }
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "addDocument", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this28 = this;

    return function (document) {
      _this28.documents.push(document);
    };
  }
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "setPdfContainerWidth", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this29 = this;

    return function (width) {
      _this29.pdfContainerWidth = width;
    };
  }
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "setSelectedTemplateIds", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this30 = this;

    return function (selectedTemplateIds) {
      _this30.selectedTemplateIds = selectedTemplateIds;
    };
  }
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "setFillableTemplateIds", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this31 = this;

    return function (fillableTemplateIds) {
      _this31.fillableTemplateIds = fillableTemplateIds;
    };
  }
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "setTemplatePickerModalOpen", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this32 = this;

    return function (templatePickerModalOpen) {
      _this32.templatePickerModalOpen = templatePickerModalOpen;
    };
  }
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "setDocuments", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this33 = this;

    return function (documents) {
      _this33.documents = documents;
    };
  }
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "setPdfWrapperRef", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this34 = this;

    return function (ref) {
      _this34.pdfWrapperRef = ref;
    };
  }
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "setTimeZone", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this35 = this;

    return function (timeZone) {
      _this35.timeZone = timeZone;
    };
  }
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "setLastKnownMouseLocation", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this36 = this;

    return function (mouseLocation) {
      _this36.lastKnownMouseLocation = mouseLocation;
    };
  }
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "setShiftKeyHeldDown", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this37 = this;

    return function (shiftKeyHeldDown) {
      _this37.shiftKeyHeldDown = shiftKeyHeldDown;
    };
  }
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "ensureNextPrevFieldPagesAreRendered", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this38 = this;

    return function (userId, userPermissions) {
      var nextField = _this38.nextField(userId, userPermissions);

      if (nextField) {
        var element = document.getElementById("fillable-field-".concat(nextField.id));

        if (!element) {
          var _this$getPageStore;

          (_this$getPageStore = _this38.getPageStore(nextField)) === null || _this$getPageStore === void 0 ? void 0 : _this$getPageStore.setRenderPageIfOutOfView(true);
        }
      }

      var prevField = _this38.previousField(userId, userPermissions);

      if (prevField) {
        var _element = document.getElementById("fillable-field-".concat(prevField.id));

        if (!_element) {
          var _this$getPageStore2;

          (_this$getPageStore2 = _this38.getPageStore(prevField)) === null || _this$getPageStore2 === void 0 ? void 0 : _this$getPageStore2.setRenderPageIfOutOfView(true);
        }
      }
    };
  }
})), _class);
export default PdfStore;
export { fieldDataComparator };